module.exports = __webpack_public_path__ + "media/images/partners/mtn-860a3b949ba6e981e1af984cc8f68141.png";